import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Button,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
  useMediaQuery,
  Grid2 as Grid,
  Menu,
  MenuItem,
  Typography,
  Divider
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import LogoMobile from "../../assets/images/Logo_Marian.png";
import LogoDesktop from "../../assets/images/Logo_Marian.svg";
import FacebookMarian from "../../assets/images/facebook_marian.svg";
import InstagramMarian from "../../assets/images/instagram_marian.svg";
import Facebookzaks from "../../assets/images/facebook_zaks.svg";
import Instagramzaks from "../../assets/images/instagram_zaks.svg";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import "./header.css";

function Header({ onSectionClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeSection, setActiveSection] = useState();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null); // Estado para manejar el menú de redes sociales

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(700));
  const Logo = isMobile ? LogoMobile : LogoDesktop;
  const sections = ["EL SUEÑO", "PRODUCTOS", "INSPIRACIÓN", "CONTÁCTANOS", "SÍGUENOS"];
  const open = Boolean(anchorEl);

  const handleSocialMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSocialMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSectionClick = (section) => {
    setActiveSection(section);
    if (section === "CONTÁCTANOS") {
      navigate("/contacto");
    } else if (section === "EL SUEÑO") {
      navigate("/empresa");
    } else {
      const sectionMap = {
        "PRODUCTOS": "products",
        "INSPIRACIÓN": "inspiration"
      }
      if (window.location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          onSectionClick(sectionMap[section]);
        }, 100);
      } else {
        onSectionClick(sectionMap[section]);
      }
    }
    setDrawerOpen(false); // cerrar el drawer si estamos en mobile
  };

  const getHeaderClass = () => {
    const section = location.pathname.split("/")[1];
    switch (section) {
      case "empresa":
        return "header-secondary";
      case "contacto":
        return "header-contact";
      case "avisoprivacidad":
        return "header-secondary";
      default:
        return "header";
    }
  }

  getHeaderClass();
  return (
    <AppBar position="static" className="header-container">
      <Toolbar
        className={getHeaderClass()}
        sx={{
          flexDirection: isMobile ? "row" : "column",
          justifyContent: isMobile ? "space-between" : "normal",
          alignItems: "center",
          px: 2,
          py: isMobile ? 1 : 2,
        }}
      >
        {isMobile ? (
          <>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                width: "auto",
                position: "absolute",
                top: isMobile ? 16 : "auto",
              }}
            >
              <Link to="/">
                <IconButton color="inherit" aria-label="logo">
                  <img src={Logo} alt="Logo Marián" className="header-logo" />
                </IconButton>
              </Link>
            </Box>
            {/* Ícono de menú hamburguesa a la derecha */}
            <IconButton
              color="inherit"
              edge="end"
              onClick={() => setDrawerOpen(true)}
              className="menu-icon"
              sx={{
                position: "absolute",
                right: 16,
                top: 16,
              }}
            >
              <MenuIcon />
            </IconButton>

            {/* Drawer */}
            <Drawer
              anchor="right"
              open={drawerOpen}
              onClose={() => setDrawerOpen(false)}
            >
              <Box
                sx={{ width: 250 }}
                role="presentation"
                onClick={() => setDrawerOpen(false)}
              >
                <List>
                  {sections.map((section) => (
                    <ListItem key={section} disablePadding>
                      <ListItemButton onClick={() => handleSectionClick(section)}>
                        <ListItemText
                          primary={section}
                          primaryTypographyProps={{
                            sx: {
                              color: activeSection === section ? "#E66671" : "#3D1C02",
                              fontWeight: "700",
                              fontSize: "12px"
                            },
                          }}
                        />
                        
                      </ListItemButton>
                    </ListItem>
                  ))}
                  <Box sx={{ padding: "10px" }}>
                    <Box className="social-container-marian">
                      <Typography variant="body2" className="social-title-marian">
                        Marián®
                      </Typography>
                      <Divider variant="middle" className="social-divider-marian" />
                      <Box className="social-icons-marian">
                        <MenuItem>
                          <a href="https://www.facebook.com/MarianGalletas" target="_blank" rel="noopener noreferrer">
                            <img src={FacebookMarian} alt="Facebook Marian" className="social-icon" />
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a href="https://www.instagram.com/galletasmarian/" target="_blank" rel="noopener noreferrer">
                            <img src={InstagramMarian} alt="Instagram Marian" className="social-icon" />
                          </a>
                        </MenuItem>
                      </Box>
                    </Box>
                    <Box className="social-container-zaks">
                      <Typography variant="body2" className="social-title-zaks">
                        Zak's®
                      </Typography>
                      <Divider variant="middle" className="social-divider-zaks" />
                      <Box className="social-icons-zaks">
                        <MenuItem>
                          <a href="https://www.facebook.com/ZaksMexicoOficial" target="_blank" rel="noopener noreferrer">
                            <img src={Facebookzaks} alt="Facebook Zak's" className="social-icon" />
                          </a>
                        </MenuItem>
                        <MenuItem>
                          <a href="https://www.instagram.com/zaksmexico/" target="_blank" rel="noopener noreferrer">
                            <img src={Instagramzaks} alt="Instagram Zak's" className="social-icon" />
                          </a>
                        </MenuItem>
                      </Box>
                    </Box>
                  </Box>
                </List>
              </Box>
            </Drawer>
          </>
        ) : (
          // Menú horizontal en desktop
          <>
            {/* Logo centrado arriba */}
            <Box sx={{ mb: 1 }}>
              <Link to="/">
                <IconButton color="inherit" aria-label="logo">
                  <img src={Logo} alt="Logo Marián" className="header-logo" />
                </IconButton>
              </Link>
            </Box>
            <Grid container justifyContent="center" alignItems="center" spacing={4} className="header-menu">
              {sections.map((section) => (
                <Grid item key={section}>
                  {section === "SÍGUENOS" ? (
                    <>
                      <Button
                        color="inherit"
                        onClick={handleSocialMenuOpen}
                        sx={{
                          color: activeSection === section ? "#E66671" : "#3D1C02",
                          fontWeight: "900",
                          fontSize: "14px",
                          backgroundColor: "transparent",
                          boxShadow: "none",
                          "&:hover": {
                            backgroundColor: "transparent",
                            color: "#E66671",
                          },
                        }}
                      >
                        {section}
                        <ExpandMoreIcon
                          fontSize="medium"
                          className="expand-icon"
                          sx={{
                            marginLeft: "2px",
                          }} />
                      </Button>
                      <Menu
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleSocialMenuClose}
                      >
                        <Box sx={{ width: 100, padding: "5px" }}>
                          <Box className="social-container-marian">
                            <Typography variant="body2" className="social-title-marian">
                              Marián®
                            </Typography>
                            <Divider variant="middle" className="social-divider-marian" />
                            <Box className="social-icons-marian">
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.facebook.com/MarianGalletas" target="_blank" rel="noopener noreferrer">
                                  <img src={FacebookMarian} alt="Facebook Marián" className="social-icon" />
                                </a>
                              </MenuItem>
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.instagram.com/galletasmarian/" target="_blank" rel="noopener noreferrer">
                                  <img src={InstagramMarian} alt="Instagram Marián" className="social-icon" />
                                </a>
                              </MenuItem>
                            </Box>
                          </Box>
                          <Box className="social-container-zaks">
                            <Typography variant="body2" className="social-title-zaks">
                              Zak's®
                            </Typography>
                            <Divider variant="middle" className="social-divider-zaks" />
                            <Box className="social-icons-zaks">
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.facebook.com/ZaksMexicoOficial" target="_blank" rel="noopener noreferrer">
                                  <img src={Facebookzaks} alt="Facebook Zaks" className="social-icon" />
                                </a>
                              </MenuItem>
                              <MenuItem onClick={handleSocialMenuClose}>
                                <a href="https://www.instagram.com/zaksmexico/" target="_blank" rel="noopener noreferrer">
                                  <img src={Instagramzaks} alt="Instagram Zaks" className="social-icon" />
                                </a>
                              </MenuItem>
                            </Box>
                          </Box>
                        </Box>
                      </Menu>
                    </>
                  ) : (
                    <Button
                      color="inherit"
                      onClick={() => handleSectionClick(section)}
                      sx={{
                        color: activeSection === section ? "#E66671" : "#3D1C02",
                        fontWeight: "900",
                        fontSize: "14px",
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:hover": {
                          backgroundColor: "transparent",
                          color: activeSection === section ? "#E66671" : "#E66671",
                        },
                      }}
                    >
                      {section}
                    </Button>
                  )}
                </Grid>
              ))}
            </Grid>
          </>
        )
        }
      </Toolbar >

    </AppBar >
  );
}

export default Header;
